export default "__VITE_ASSET__4b7006a9__"